import { API_BASE_URL, IFRAME_NON_STRICT_MODE } from '../../library/globals';
import { OutgoingActions } from './persistent-iframe.constants';
import { getAppMetadata } from './persistent-iframe.app-metadata';

const allMessageQueues: Record<string, any> = {};
const isAppLoaded: Record<string, boolean> = {};

const sendMessageToIframeWindow = (appName: string, message: string) => {
    const metadata = getAppMetadata(appName);
    if (!metadata) return;
    const frameId = metadata.iframeId;
    // Resolve via getElementById, not window.frames[id]: the iframe is rendered
    // through a portal to document.body and has no `name` attribute, so the
    // named-frames lookup returns the nested WindowProxy (whose `.contentWindow`
    // is undefined) and the post throws before reaching the iframe.
    const frameEl = document.getElementById(frameId) as HTMLIFrameElement | null;
    const frameWindow = frameEl?.contentWindow
        || ((window.frames as any)[frameId]?.contentWindow as Window | undefined);
    if (!frameWindow) {
        if (process.env.NODE_ENV !== 'production') {
            // eslint-disable-next-line no-console
            console.warn(`[custom-frontend] iframe "${frameId}" not found/ready — message dropped`);
        }
        return;
    }
    const origin = IFRAME_NON_STRICT_MODE ? '*' : metadata.origin;
    frameWindow.postMessage(message, origin);
};

const checkIfAppLoaded = (appName: string) => {
    return isAppLoaded[appName] || false;
};

export const setAppLoaded = (appName: string) => {
    isAppLoaded[appName] = true;
};

export const sendMessage = (appName: string, message: string) => {
    if (checkIfAppLoaded(appName)) {
        sendMessageToIframeWindow(appName, message);
    } else {
        allMessageQueues[appName] = (allMessageQueues[appName] || []).concat(message);
    }
};

export const flushMessageQueue = (appName: string) => {
    const queue = allMessageQueues[appName] || [];
    queue.forEach((message: string) => {
        sendMessageToIframeWindow(appName, message);
    });
};

export const sendRoutingEvent = (appName: string, route: string) => {
    const stringifiedRoute = JSON.stringify({
        type: OutgoingActions.Routing,
        data: route,
    });
    sendMessage(appName, stringifiedRoute);
};

export const sendCredentials = (appName: string, credentials: any) => {
    const apiBaseUrl = new URL(API_BASE_URL);
    const stringifiedCredentials = JSON.stringify({
        type: OutgoingActions.CREDENTIALS_SHARING,
        data: {
            ...credentials,
            'parent-url': window.location.href,
            'project-name': 'customer-logistics',
            'api-base-url': apiBaseUrl.hostname,
        },
    });
    sendMessage(appName, stringifiedCredentials);
};
